// extracted by mini-css-extract-plugin
export default {"zoomModal":"U6-z"};